var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C7.01071 0 7.42857 0.405 7.42857 0.9V3.6H18.5714V0.9C18.5714 0.405 18.9893 0 19.5 0C20.0107 0 20.4286 0.405 20.4286 0.9V3.6H22.2857C24.3344 3.6 26 5.21438 26 7.2V23.4C26 25.3856 24.3344 27 22.2857 27H3.71429C1.66562 27 0 25.3856 0 23.4V7.2C0 5.21438 1.66562 3.6 3.71429 3.6H5.57143V0.9C5.57143 0.405 5.98929 0 6.5 0ZM22.2857 5.4H3.71429C2.68705 5.4 1.85714 6.20437 1.85714 7.2V9H24.1429V7.2C24.1429 6.20437 23.3129 5.4 22.2857 5.4ZM24.1429 10.8H1.85714V23.4C1.85714 24.3956 2.68705 25.2 3.71429 25.2H22.2857C23.3129 25.2 24.1429 24.3956 24.1429 23.4V10.8Z",
    fill: "#B88333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d172d6f613d170819a719cf9051e00ca.svg";
export { ForwardRef as ReactComponent };